import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { PageHeader } from "../../../components/header/PageHeader";
import {
  kindergartenApplicationsListTable,
  KindergartenApplicationState,
  kinderTableOptionsBuilder,
} from "../../../shared/tableObjects/kindergarten/kindergartenApplicationListTable";
import { useAccount, useMsal } from "@azure/msal-react";

export default function KindergartenApplicationsListSubmitted() {
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const apiClient = useApiClient("InvitedApplications");

  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "List of Applications",
      icon: "list-icon",
    },
  ];

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <Table
          apiClient={apiClient}
          columns={kindergartenApplicationsListTable("/kindergarten/submittedApplications", KindergartenApplicationState.submitted)}
          route={`allMyInvited/${account?.idTokenClaims?.["extension_ApplicationIds"]}`}
          tableOptions={kinderTableOptionsBuilder(KindergartenApplicationState.submitted)}
        />
      </div>
    </>
  );
}
